import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeScreenComponent } from "./welcome/home-screen/home-screen.component";
import { AuthGuard } from "./_helpers/auth.guard";
import { NotAuthGuard } from "./_helpers/not-auth.guard";

const routes: Routes = [
  {
    path: "welcome",
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: HomeScreenComponent,
        canActivate: [NotAuthGuard],
      },
      {
        path: "start",
        canActivate: [NotAuthGuard],
        loadChildren: () =>
          import("./welcome/start/start.module").then((m) => m.StartModule),
      },
      {
        path: "contact",
        canActivate: [NotAuthGuard],
        loadChildren: () =>
          import("./welcome/contact/contact.module").then((m) => m.ContactModule),
      },
      {
        path: "menu",
        canActivate: [AuthGuard],
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./welcome/home-menu/home-menu.module").then(
                (m) => m.HomeMenuModule
              ),
          },
          {
            path: "password-update",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/password-update/password-update.module"
                  ).then((m) => m.PasswordUpdateModule),
              },
            ],
          },
          {
            path: "contact-us",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import("./welcome/contact/contact.module").then((m) => m.ContactModule),
              },
            ],
          },
          {
            path: "discover-insurrrance",
            loadChildren: () =>
              import(
                "./welcome/home-menu/discover-insurrance/discover-insurrance.module"
              ).then((m) => m.DiscoverInsurranceModule),
          },
          {
            path: "our-products-and-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/products-and-services/products-and-services.module"
                  ).then((m) => m.ProductsAndServicesModule),
              },
            ],
          },
          {
            path: "automobile/automobile-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-services/automobile-services.module"
                  ).then((m) => m.AutomobileServicesModule),
              },
            ],
          },
          {
            path: "automobile/avenants-automobile-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-avenant-form/automobile-avenant-form.module"
                  ).then((m) => m.AutomobileAvenantFormModule),
              },
            ],
          },
          {
            path: "automobile/avenants-automobile",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-avenant-control/automobile-avenant-control.module"
                  ).then((m) => m.AutomobileAvenantControlModule),
              },
            ],
          },
          {
            path: "automobile/automobile-quotation-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-quotation-form/automobile-quotation-form.module"
                  ).then((m) => m.AutomobileQuotationFormModule),
              },
            ],
          },
          {
            path: "automobile/historique-souscription",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/automobile-souscription-history/automobile-souscription-history.module"
                  ).then((m) => m.AutomobileSouscriptionHistoryModule),
              },
            ],
          },
          {
            path: "bancassurance/bancassurance-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-services/bancassurance-services.module"
                  ).then((m) => m.BancassuranceServicesModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-menus",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-menus/bancassurance-responsable-menus.module").then((m) => m.BancassuranceResponsableMenusModule),
              },
            ],
          },
          {
            path: "bancassurance/producteur-menus",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-producteur-menus/bancassurance-producteur-menus.module").then((m) => m.BancassuranceProducteurMenusModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-policy-management",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-policy-management/bancassurance-responsable-policy-management.module"
                  ).then((m) => m.BancassuranceResponsablePolicyManagementModule),
              },
            ],
          },
          {
            path: "bancassurance/producteur-policy-management",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-producteur-policy-management/bancassurance-producteur-policy-management.module"
                  ).then((m) => m.BancassuranceProducteurPolicyManagementModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-commissions",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-commissions/bancassurance-responsable-commissions.module"
                  ).then((m) => m.BancassuranceResponsableCommissionsModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-virements",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-virements/bancassurance-responsable-virements.module"
                  ).then((m) => m.BancassuranceResponsableVirementsModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-ristournes",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-discounts/bancassurance-responsable-discounts.module"
                  ).then((m) => m.BancassuranceResponsableDiscountsModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-support",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-support/bancassurance-responsable-support.module"
                  ).then((m) => m.BancassuranceResponsableSupportModule),
              },
            ],
          },
          {
            path: "bancassurance/responsable-sinisters",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-responsable-sinisters/bancassurance-responsable-sinisters.module"
                  ).then((m) => m.BancassuranceResponsableSinistersModule),
              },
            ],
          },
          {
            path: "bancassurance/admin-menus",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-menus/bancassurance-admin-menus.module"
                  ).then((m) => m.BancassuranceAdminMenusModule),
              },
            ],
          },
          {
            path: "bancassurance/admin-users",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/bancassurance-admin-users/bancassurance-admin-users.module"
                  ).then((m) => m.BancassuranceAdminUsersModule),
              },
            ],
          },
          {
            path: "accident/accident-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/accident-services/accident-services.module"
                  ).then((m) => m.AccidentServicesModule),
              },
            ],
          },
          {
            path: "accident/accident-subscription-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/accident-subscription-form/accident-subscription-form.module"
                  ).then((m) => m.AccidentSubscriptionFormModule),
              },
            ],
          },
          {
            path: "home/home-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/home-services/home-services.module"
                  ).then((m) => m.HomeServicesModule),
              },
            ],
          },
          {
            path: "home/home-subscription-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/home-subscription-form/home-subscription-form.module"
                  ).then((m) => m.HomeSubscriptionFormModule),
              },
            ],
          },
          {
            path: "travel/travel-services",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/travel-services/travel-services.module"
                  ).then((m) => m.TravelServicesModule),
              },
            ],
          },
          {
            path: "travel/travel-subscription-form",
            children: [
              {
                path: "",
                loadChildren: () =>
                  import(
                    "./welcome/home-menu/travel-subscription-form/travel-subscription-form.module"
                  ).then((m) => m.TravelSubscriptionFormModule),
              },
            ],
          },
        ],
      },
      {
        path: "thankyou",
        loadChildren: () =>
          import("./welcome/exit-screen/exit-screen.module").then(
            (m) => m.ExitScreenModule
          ),
      },
      {
        path: "intro",
        loadChildren: () =>
          import("./welcome/intro-screen/intro-screen.module").then(
            (m) => m.IntroScreenModule
          ),
      },
    ],
  },
  { path: "", redirectTo: "/welcome/home", pathMatch: "full" },
  {
    path: "**",
    redirectTo: "/welcome/home",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
